import React from "react";
import "./Switch.css";

const Switch = ({ id, name, checked, onChange, label }) => {
  return (
    <div className="switch-container">
      <label htmlFor={id} className="switch-label">
        {label}
      </label>
      <label className="switch">
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default Switch;
